import { render, staticRenderFns } from "./ProductCardSlider.vue?vue&type=template&id=1ae4554d&scoped=true"
import script from "./ProductCardSlider.vue?vue&type=script&lang=js"
export * from "./ProductCardSlider.vue?vue&type=script&lang=js"
import style0 from "./ProductCardSlider.vue?vue&type=style&index=0&id=1ae4554d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae4554d",
  null
  
)

export default component.exports